module.exports = __webpack_public_path__ + "img/2.4c5e3102.png";